export async function getPMSValidRoute(hUser, userPermissions, $stateParams) {
    let brandId = parseInt($stateParams["brand_id"]);
    let brandIds = [brandId];
    for (let i = 0; i < hUser.data.user.brands_list.length; i++) {
        brandIds.push(hUser.data.user.brands_list[i].id);
    }
    let promises = [
        userPermissions.getBrandPolicy(brandId),
        userPermissions.getBrandPolicy(brandIds)
    ];
    let res = await Promise.all(promises);
    if (res[1].clone().brand(res[1].ANY).has(userPermissions.PERMISSIONS['VIEW_PERFORMANCE_REVIEW_DASHBOARD'])) {
        return 'appLayout.harriSH.pms.dashboard';
    }
    else if ('MANAGE_QUESTIONS_AND_TEMPLATES_BANK' in userPermissions.PERMISSIONS && res[0].has(userPermissions.PERMISSIONS['MANAGE_QUESTIONS_AND_TEMPLATES_BANK'])) {
        return 'appLayout.harriSH.pms.questions-and-templates';
    }
    else if ('MANAGE_REVIEW_CYCLES' in userPermissions.PERMISSIONS && res[0].has(userPermissions.PERMISSIONS['MANAGE_REVIEW_CYCLES'])) {
        return 'appLayout.harriSH.pms.reviews-management';
    }
    return 'appLayout.harriSH.pms.reviews';
}
export const PmsRoutes = [
    {
        "url": "/pms/:brand_id?type",
        "name": "appLayout.harriSH.pms",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "abstract": true,
        "component": 'pms',
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/pms/pms.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/pms/pms-shared.downgrade.module");
                }
            }
        ],
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', '$stateParams', async (hUser, brandServices, userPermissions, $state, $stateParams) => {
                return new Promise(async (resolve, reject) => {
                    let brandId = parseInt($stateParams["brand_id"]);
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                    ];
                    let res = await Promise.all(promises);
                    if (res[0]) {
                        resolve();
                    }
                    else {
                        reject();
                        Utils.redirectToWorkspace('homepage');
                    }
                });
            }],
        "resolve": {
            prerequisiteServiceCheck: ['$state', '$stateParams', 'pmsGeneralSettingsService', async function ($state, $stateParams, pmsGeneralSettingsService) {
                    const brandId = $stateParams['brand_id'];
                    const brand = await GPSAPI.getGP(brandId);
                    const manageLevelPMS = await pmsGeneralSettingsService.checkManagementLevel(brand.type);
                    if (!manageLevelPMS.canAccessSameAndBelowLevel) {
                        $state.go('appLayout.harriSH.dashboard');
                    }
                    else {
                        if (!manageLevelPMS.canAccessSameLevel) {
                            const managementBrandId = await pmsGeneralSettingsService.getManagementBrandId(brandId);
                            $state.go('appLayout.harriSH.pms.reviews', { brand_id: managementBrandId, type: brand.type });
                        }
                    }
                }],
        }
    },
    {
        "url": "/pms-dashboard",
        "name": "appLayout.harriSH.pms.dashboard",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "PmsDashboardContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms'],
        },
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', '$stateParams', async (hUser, brandServices, userPermissions, $state, $stateParams) => {
                return new Promise(async (resolve, reject) => {
                    let brandId = parseInt($stateParams["brand_id"]);
                    let brandIds = [brandId];
                    for (let i = 0; i < hUser.data.user.brands_list.length; i++) {
                        brandIds.push(hUser.data.user.brands_list[i].id);
                    }
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                        userPermissions.getBrandPolicy(brandIds),
                    ];
                    let res = await Promise.all(promises);
                    if (res[0] && res[1].clone().brand(res[1].ANY).has(userPermissions.PERMISSIONS['VIEW_PERFORMANCE_REVIEW_DASHBOARD'])) {
                        resolve(true);
                    }
                    else {
                        let validRoute = await getPMSValidRoute(hUser, userPermissions, $stateParams);
                        if (validRoute) {
                            $state.go(validRoute, { brand_id: brandId });
                        }
                        else {
                            reject();
                            Utils.redirectToWorkspace('homepage');
                        }
                    }
                });
            }],
    },
    {
        "url": "/questions-and-templates?tab",
        "name": "appLayout.harriSH.pms.questions-and-templates",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsQuestionsAndTemplates",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        },
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', '$stateParams', async (hUser, brandServices, userPermissions, $state, $stateParams) => {
                return new Promise(async (resolve, reject) => {
                    let brandId = parseInt($stateParams["brand_id"]);
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                        await userPermissions.getBrandPolicy(brandId)
                    ];
                    let res = await Promise.all(promises);
                    if (res[0] && 'MANAGE_QUESTIONS_AND_TEMPLATES_BANK' in userPermissions.PERMISSIONS && res[1].has(userPermissions.PERMISSIONS['MANAGE_QUESTIONS_AND_TEMPLATES_BANK'])) {
                        resolve();
                    }
                    else {
                        let validRoute = await getPMSValidRoute(hUser, userPermissions, $stateParams);
                        if (validRoute) {
                            $state.go(validRoute, { brand_id: brandId });
                        }
                        else {
                            reject();
                            Utils.redirectToWorkspace('homepage');
                        }
                    }
                });
            }],
    },
    {
        "url": "/questions?question_id=&edit=",
        "name": "appLayout.harriSH.pms.manage-questions",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsManageQuestions",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        }
    }, {
        "url": "/pms-dashboard",
        "name": "appLayout.harriSH.pms.dashboard",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsDashboard",
            }
        },
        "route_dependencies": [
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms'],
        }
    },
    {
        "url": "/templates?template_id=&edit=",
        "name": "appLayout.harriSH.pms.manage-templates",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsManageTemplates",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        }
    },
    {
        "url": "/reviews-management?tab",
        "name": "appLayout.harriSH.pms.reviews-management",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsManagementReviews",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        },
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', '$stateParams', async (hUser, brandServices, userPermissions, $state, $stateParams) => {
                return new Promise(async (resolve, reject) => {
                    let brandId = parseInt($stateParams["brand_id"]);
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                        await userPermissions.getBrandPolicy(brandId)
                    ];
                    let res = await Promise.all(promises);
                    if (res[0] && 'MANAGE_REVIEW_CYCLES' in userPermissions.PERMISSIONS && res[1].has(userPermissions.PERMISSIONS['MANAGE_REVIEW_CYCLES'])) {
                        resolve();
                    }
                    else {
                        let validRoute = await getPMSValidRoute(hUser, userPermissions, $stateParams);
                        if (validRoute) {
                            $state.go(validRoute, { brand_id: brandId });
                        }
                        else {
                            reject();
                            Utils.redirectToWorkspace('homepage');
                        }
                    }
                });
            }],
    },
    {
        "url": "/reviews",
        "name": "appLayout.harriSH.pms.reviews",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsReviewsContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        },
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', '$stateParams', async (hUser, brandServices, userPermissions, $state, $stateParams) => {
                return new Promise(async (resolve, reject) => {
                    let brandId = parseInt($stateParams["brand_id"]);
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                        await userPermissions.getBrandPolicy(brandId),
                    ];
                    let res = await Promise.all(promises);
                    if (res[0]) {
                        resolve();
                    }
                    else {
                        let validRoute = await getPMSValidRoute(hUser, userPermissions, $stateParams);
                        if (validRoute) {
                            $state.go(validRoute, { brand_id: brandId });
                        }
                        else {
                            reject();
                            Utils.redirectToWorkspace('homepage');
                        }
                    }
                });
            }],
    },
    {
        "url": "/check-in",
        "name": "appLayout.harriSH.pms.check-in",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsCheckInWrapperContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        },
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', '$stateParams', async (hUser, brandServices, userPermissions, $state, $stateParams) => {
                return new Promise(async (resolve, reject) => {
                    let brandId = parseInt($stateParams["brand_id"]);
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                        await userPermissions.getBrandPolicy(brandId),
                    ];
                    let res = await Promise.all(promises);
                    if (res[0]) {
                        resolve();
                    }
                    else {
                        let validRoute = await getPMSValidRoute(hUser, userPermissions, $stateParams);
                        if (validRoute) {
                            $state.go(validRoute, { brand_id: brandId });
                        }
                        else {
                            reject();
                            Utils.redirectToWorkspace('homepage');
                        }
                    }
                });
            }],
    },
    {
        "url": "/review-cycle-overview/:review_cycle_id",
        "name": "appLayout.harriSH.pms.review-cycle-overview",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsReviewCycleOverviewContainer",
            }
        },
        "route_dependencies": [
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        }
    },
    {
        "url": "/review_cycles?review_cycle_id=&edit=",
        "name": "appLayout.harriSH.pms.manage-reviews-container",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsManageReviewsContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        }
    },
    {
        "url": "/reviews/:id",
        "name": "appLayout.harriSH.pms.employee-reviews-management",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsManagementEmployeeReviews",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        }
    },
    {
        "url": "/reviews/:id/:user_id",
        "name": "appLayout.harriSH.pms.run-employee-review",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsTeamEmployeeReviewContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        }
    },
    {
        "url": "/single-reviews/:review_cycle_id",
        "name": "appLayout.harriSH.pms.single-employee-review",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsTeamEmployeeReviewContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        }
    },
    {
        "url": "/bulk-review/:id",
        "name": "appLayout.harriSH.pms.bulk-review",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsBulkReviewContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        }
    },
    {
        "url": "/bulk-approve/:id",
        "name": "appLayout.harriSH.pms.bulk-approve",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsBulkReviewApprovalContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        }
    },
    {
        "url": "/overall-rating",
        "name": "appLayout.harriSH.pms.overall-rating",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsOverallRating",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        },
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', '$stateParams', async (hUser, brandServices, userPermissions, $state, $stateParams) => {
                return new Promise(async (resolve, reject) => {
                    let brandId = parseInt($stateParams["brand_id"]);
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                        await userPermissions.getBrandPolicy(brandId)
                    ];
                    let res = await Promise.all(promises);
                    if (res[0] && 'MANAGE_OVERALL_RATING_RULES' in userPermissions.PERMISSIONS && res[1].has(userPermissions.PERMISSIONS['MANAGE_OVERALL_RATING_RULES'])) {
                        resolve();
                    }
                    else {
                        let validRoute = await getPMSValidRoute(hUser, userPermissions, $stateParams);
                        if (validRoute) {
                            $state.go(validRoute, { brand_id: brandId });
                        }
                        else {
                            reject();
                            Utils.redirectToWorkspace('homepage');
                        }
                    }
                });
            }],
    },
    {
        "url": "/general-settings",
        "name": "appLayout.harriSH.pms.general-settings",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsGeneralSettings",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        },
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', '$stateParams', async (hUser, brandServices, userPermissions, $state, $stateParams) => {
                return new Promise(async (resolve, reject) => {
                    let brandId = parseInt($stateParams["brand_id"]);
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                        await userPermissions.getBrandPolicy(brandId)
                    ];
                    let res = await Promise.all(promises);
                    if (res[0] && 'MANAGE_PMS_GENERAL_SETTINGS' in userPermissions.PERMISSIONS && res[1].has(userPermissions.PERMISSIONS['MANAGE_PMS_GENERAL_SETTINGS'])) {
                        resolve();
                    }
                    else {
                        let validRoute = await getPMSValidRoute(hUser, userPermissions, $stateParams);
                        if (validRoute) {
                            $state.go(validRoute, { brand_id: brandId });
                        }
                        else {
                            reject();
                            Utils.redirectToWorkspace('homepage');
                        }
                    }
                });
            }],
    },
    {
        "url": "/notifications",
        "name": "appLayout.harriSH.pms.notifications",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsNotifications",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        },
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', '$stateParams', async (hUser, brandServices, userPermissions, $state, $stateParams) => {
                return new Promise(async (resolve, reject) => {
                    let brandId = parseInt($stateParams["brand_id"]);
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                        await userPermissions.getBrandPolicy(brandId)
                    ];
                    let res = await Promise.all(promises);
                    if (res[0] && 'MANAGE_PMS_GENERAL_SETTINGS' in userPermissions.PERMISSIONS && res[1].has(userPermissions.PERMISSIONS['MANAGE_PMS_GENERAL_SETTINGS'])) {
                        resolve();
                    }
                    else {
                        let validRoute = await getPMSValidRoute(hUser, userPermissions, $stateParams);
                        if (validRoute) {
                            $state.go(validRoute, { brand_id: brandId });
                        }
                        else {
                            reject();
                            Utils.redirectToWorkspace('homepage');
                        }
                    }
                });
            }],
    },
    {
        "url": "/check-in-setting",
        "name": "appLayout.harriSH.pms.check-in-setting",
        "type": "frontend",
        "loginRequired": true,
        "platformPage": true,
        "views": {
            "body": {
                "component": "pmsCheckInSetting",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['pms', 'pms-shared'],
        } /*,
        "onEnter": ['hUser', 'brandServices', 'userPermissions', '$state', async (hUser: hUserService, brandServices: BrandServices, userPermissions: UserPermissionsService, $state: IStateService) => {
            return new Promise(async (resolve, reject) => {
                let brandId = hUser.getEntryMode().brand_id;
                let promises = [
                    brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandId, true),
                    await userPermissions.getBrandPolicy(brandId),
                    GPSAPI.getGP(brandId)
                ];
                let res = await Promise.all(<any[]>promises);
                if (res[0] && 'MANAGE_PMS_GENERAL_SETTINGS' in userPermissions.PERMISSIONS && res[1].has(userPermissions.PERMISSIONS['MANAGE_PMS_GENERAL_SETTINGS']) && brandId === res[2].parent_id) {
                    resolve();
                } else {
                    let validRoute = await getPMSValidRoute(hUser, userPermissions);
                    if (validRoute) {
                        $state.go(validRoute);
                    } else {
                        reject();
                        Utils.redirectToWorkspace('homepage');
                    }
                }
            })
        }],*/
    }
];
//# sourceMappingURL=pms.routes.js.map